<template>
<div class="card">
    <div class="card--image">
        <h2>{{ alt }}</h2>
        <!-- <div class='text-right'>
            <a href="/abbreviations" target="_blank" rel="noopener noreferrer" class="btn btn-secondary">Abbreviations</a>
        </div> -->
        <div v-if="existsrc == 'true'">
            <!-- <b-img center :src="url" :alt="alt" :id="id" fluid-grow></b-img> -->
            <img :src="url" :alt="alt" :id="id">
        </div>
        <div v-else>
            <span>No data.</span>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        url: String,
        alt: String,
        existsrc: String,
        id: String
    }
}
</script>

<style scoped>
img {
  position: relative;
  /* max-width: 1024px !important; */
}
#subset {
  /* max-width: 640px !important; */
  max-width: calc(1024px * 0.625) !important;
  width: 62.5% !important;
}
#comp {
  /* max-width: 1024px !important; */
  max-width: calc(1024px * 1) !important;
  width: 100% !important;
}
#eqtlplot {
  /* max-width: 768px !important; */
  max-width: calc(1024px * 0.75) !important;
  width: 75% !important;
}
</style>
